import React, { useEffect, useState } from 'react';
import { Modal, Backdrop, Box, CircularProgress } from '@mui/material';
import { useLoader } from '../../provider/LoaderProvider';
import { sxConfig } from './interface.style';

const LoaderUI = () => {
  const { loading } = useLoader();
  const [dots, setDots] = useState(0);

  useEffect(() => {
    const id = setInterval(() => setDots((d) => (d + 1) % 4), 500);
    return () => clearInterval(id);
  }, []);

  const text = `Betöltés${'.'.repeat(dots)}`;

  return (
    <Modal
      open={!!loading}
      keepMounted
      closeAfterTransition
      hideBackdrop
      slots={{
        backdrop: Backdrop,
      }}
      disableEnforceFocus
      disableAutoFocus
    >
      <Box sx={sxConfig.loaderWrapper}>
        <Box sx={sxConfig.loaderBackdrop} />
        <Box sx={sxConfig.loaderContent}>
          <CircularProgress size={70} />
          <Box sx={sxConfig.loaderText} aria-live="polite">
            {text}
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default LoaderUI;
